import { React, useEffect, useRef, useState } from "react";
import './Facility.css';

import FacilityDetail from './FacilityPages/FacilityDetail.js';

import { Link } from "react-router-dom";
import { getFirestore, collection, getDocs, doc, query, orderBy, limit , where} from "firebase/firestore"; // 데이터 읽어오기

function Facility(props) {
  return (
    <div className="Facility">
      <div className="Facility_PC flex w-full justify-center">
        <div className="Facility_PC-Facility flex con">
          <div className="MenuArea flex">
            <div className="MenuAreaList flex flex-col">
              <div>설비현황</div>
            </div>
          </div>
          <div className="FacilityList flex flex-col">
            <div className="flex SubHead">본사</div>
            <div className="flex h-6"></div>
            <div className="ListIMG flex w-full gap-4">
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HOPlant1.jpg" alt="설비현황1"></img>
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HOPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"본사"} />

            <div className="flex h-10"></div>

            <div className="flex SubHead">열처리</div>
            <div className="flex h-6"></div>
            <div className="ListIMG flex w-full gap-4">
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HTPlant1.jpg" alt="설비현황1"></img>
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HTPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"열처리"} />

            <div className="flex h-10"></div>

            <div className="flex SubHead">단조</div>
            <div className="flex h-6"></div>
            <div className="ListIMG flex w-full gap-4">
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HDPlant1.jpg" alt="설비현황1"></img>
              <img className="flex flex-1" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883348/HDPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"단조"} />

            <div className="flex h-10"></div>

          </div>
        </div>
      </div>

      <div className="Facility_MB flex flex-col">
        <div className="FacilityBanner flex flex-col w-full">
          <div className="MenuArea flex">
            <div className="MenuAreaList flex flex-col">
              <div>설비현황</div>
            </div>
          </div>
        </div>
        <div className="flex h-14"></div>
        <div className="FacilityList flex flex-col">
          <div className="flex w-full flex-col">
            <div className="flex SubHead">본사</div>
            <div className="flex h-4"></div>
            <div className="ListIMG flex flex-col w-full">
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HOPlant1.jpg" alt="설비현황1"></img>
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HOPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"본사"} />        
          </div>

          <div className="flex h-10"></div>   

          <div className="flex w-full flex-col">
            <div className="flex SubHead">열처리</div>
            <div className="flex h-4"></div>
            <div className="ListIMG flex flex-col w-full">
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HTPlant1.jpg" alt="설비현황1"></img>
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HTPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"열처리"} />       
          </div>

          <div className="flex h-10"></div>   

          <div className="flex w-full flex-col">
            <div className="flex SubHead">단조</div>
            <div className="flex h-4"></div>
            <div className="ListIMG flex flex-col w-full">
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HDPlant1.jpg" alt="설비현황1"></img>
              <img className="flex" src="https://res.cloudinary.com/djjgjsktx/image/upload/v1774883333/HDPlant2.jpg" alt="설비현황2"></img>
            </div>
            <FacilityDetail db={props.db} FcSpotType={"단조"} />
          </div>

          <div className="flex h-20"></div>   

        </div>
          
      </div>

    </div>
  );
}

export default Facility;
